"use client";

import { useEffect } from "react";

/** Registers the PWA service worker in production (and dev if NEXT_PUBLIC_PWA_DEV=1). */
export function RegisterServiceWorker() {
  useEffect(() => {
    if (typeof window === "undefined" || !("serviceWorker" in navigator)) return;

    const enableInDev = process.env.NEXT_PUBLIC_PWA_DEV === "1";
    if (process.env.NODE_ENV !== "production" && !enableInDev) return;

    const reg = navigator.serviceWorker.register("/sw.js", {
      scope: "/",
      type: "classic",
      updateViaCache: "none",
    });
    reg.catch(() => {
      /* ignore registration errors (insecure origin, blocked, etc.) */
    });
  }, []);

  return null;
}
